import * as SagasType from '../constants/constant_saga_types';

export function simpleFormReducer(state = {}, action) {
  switch (action.type) {
    case SagasType.SIMPLE_FORM_FETCH_IN_PROGRESS: {
      return {
        isFetching: true
      }
    }
    case SagasType.SIMPLE_FORM_ERROR: {
      return {
        error: action.error
      }
    }
    case SagasType.SIMPLE_FORM_SET_DATA: {
      return {
        data: action.data
      }
    }
    case SagasType.SIMPLE_FORM_RESET_DATA: {
      return {
        data: action.initialValues || { active: true }
      }
    }
    default: {
      return state;
    }
  }
}